<div class="vbox mask-container">
  <div class="mat-h3 separator"><span class="label">Trucking Info</span>{{piece.id}}</div>
  <div class="hbox-nowrap">
    <div class="hbox-nowrap">
      <app-display-multi-line label="Pick-up Address" [value]="piece.forwarderPickupAddress"></app-display-multi-line>
      <app-display-multi-line label="Delivery Address"
        [value]="piece.forwarderDeliveryAddress"></app-display-multi-line>
    </div>
    <div class="hbox">
      <app-display-value label="Driver" size="small" [value]="piece.driverName"></app-display-value>
      <app-display-value label="Passport/ID" size="small" [value]="piece.driverId"></app-display-value>
      <app-display-value label="Truck ID" size="small" [value]="piece.truckId"></app-display-value>
      <app-display-value label="Trucking Company" [value]="piece.truckCompany"></app-display-value>
      <app-display-value label="Marking" [value]="piece.otherIdentifier"></app-display-value>
      <app-display-value label="Handling Instructions" [value]="piece.handlingInstructions"></app-display-value>
    </div>
  </div>
  <div class="mat-h3 separator"><span class="label">Shipment Info</span></div>
  <div class="hbox">
    <app-display-value label="Destination" [value]="piece.flightArrival"></app-display-value>
    <app-display-value label="LAT" [value]="piece.lat"></app-display-value>
    <app-display-value label="CHA" [value]="piece.cha"></app-display-value>
    <app-display-value label="SPX-Status" [value]="piece.spxStatus"></app-display-value>
    <app-display-value label="Customs" value="Cleared"></app-display-value>
    <app-display-value label="Master AWB" [value]="shipment.masterAwb"></app-display-value>
    <app-display-value label="House AWB" [value]="shipment.houseAwb"></app-display-value>
    <app-display-value label="Client" [value]="shipment.client"></app-display-value>
    <app-display-value label="No. of Pieces" size="small" [value]="shipment.pieceCount"></app-display-value>
    <app-display-value label="Tot. Gross Weight" [value]="shipment.grossWeight"></app-display-value>
    <app-display-value label="Charg. Weight" [value]="shipment.chargeableWeight"></app-display-value>
    <app-display-value label="Volume" size="small" [value]="shipment.volume"></app-display-value>
    <app-display-value label="Commodity" [value]="piece.commodity"></app-display-value>

  </div>
  <div class="mat-h3 separator-no-space"><span class="label">Piece Info</span></div>
  <div class="vbox">
    <app-pieces-table [otherPieces]="otherPieces" (select)="click($event)"></app-pieces-table>
  </div>
</div>